import { LoginForm } from '@components/Component/Container/Form/LoginForm/LoginForm.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { ENV } from '@components/Environment.js';
import { oAuthPopup } from '@components/Utility/index.js';
import { eventContextGet } from '@components/EventConfigManager/EventConfigManagerUtil.js';
export class LoginFormOverlay extends LoginForm {
    constructor() {
        super(...arguments);
        this.componentName = 'LoginFormOverlay';
    }
    draw() {
        super.draw();
        this.rootElement.classList.add('s360LoginForm');
    }
    initializeComponents() {
        super.initializeComponents();
        //this.componentRemove('forgotpassword')
        // we'll just override the existing forgot password component so we don't have to redo the template
        const forgotpassword = this.componentGet('forgotpassword');
        if (forgotpassword) {
            forgotpassword.captionKey = 'system_login_logout';
            forgotpassword.before('click', () => {
                window.location.reload();
                return false;
            });
        }
    }
    oAuthButtonClick(webmailconfigno) {
        oAuthPopup({ webmailconfigno }, eventContextGet({ initiator: this })).subscribe(() => {
            this.finalizeLogin('oauth');
        });
    }
    login() {
        const enteredUserId = this.record?.get('userid');
        const sessionUserId = ENV('userId');
        const sessionNetworkLogin = ENV('networkLogin');
        if (!enteredUserId) {
            return;
        }
        if (enteredUserId.toUpperCase() !== sessionUserId.toUpperCase() && enteredUserId.toUpperCase() !== sessionNetworkLogin.toUpperCase()) {
            this.confirm({ captionKey: 'system_login_restore_wrong_userid' })
                .subscribe(() => {
                window.location.reload();
            });
        }
        else {
            super.login();
        }
    }
    mainHeadingCaptionGet(subHeading = false) {
        let caption;
        if (subHeading) {
            caption = this.CaptionManager.getCaption('system_login_subheading_expired');
        }
        else {
            caption = this.CaptionManager.getCaption('system_login_heading_expired');
        }
        return caption;
    }
    finalizeLogin(source = 'login') {
        const bm = DIContainer.getInstance('BroadcastManager');
        bm.send('session-restored', { payload: { source: source } });
    }
}
LoginFormOverlay.VERSION = '$Revision: 123195 $';
